/* eslint-disable consumerweb/no-manual-pxp */
/**
 * PXP Experimentation helper
 */
define([], function() {

	'use strict';

	// grab the features off of the <body>
	var data = document.body.getAttribute('data-pxp');
	var globalExperiments = {};
	try {
		globalExperiments = JSON.parse(data) || {};
	} catch (e) {
		// basically ignore this because oh well
	}

	// return a simple API that lets us determine if features are available
	// Ex: if (pxp.isTreatment("your-feature")) { /* ... */ }
	return {
		isTreatment: function(treatment, response) {
			var experiments = response && response.data && response.data.experimentModel;
			return (experiments || globalExperiments)[treatment];
		}
	};
});



//////////////////
// WEBPACK FOOTER
// ./lib/pxp.js
// module id = 45
// module chunks = 0